import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "redux-store/store";

const recruitmentSelector = (state: RootState) => state.recruitment;

//========================================
const formSearchRecruitmentSelector = createSelector(
  recruitmentSelector,
  (state) => state.formSearchRecruitmentReducer
);

export const formSearchRecruitmentDataSelector = createSelector(
  formSearchRecruitmentSelector,
  (state) => state.formData
);

//========================================
export const listRecruitmentRequirementSelector = createSelector(
  recruitmentSelector,
  (state) => state.getListRecruitmentRequirementReducer
);

export const listRecruitmentRequirementDataSelector = createSelector(
  listRecruitmentRequirementSelector,
  (state) => state.data
);

//========================================
export const rejectFormRecruitmentSelector = createSelector(
  recruitmentSelector,
  (state) => state.rejectRecruitmentRequirementReducer
);

export const rejectFormRecruitmentDataSelector = createSelector(
  rejectFormRecruitmentSelector,
  (state) => state.formData
);

export const formInputRecruitmentSelector = createSelector(
  recruitmentSelector,
  (state) => state.formInput.data
);

export const isModalUpdate = createSelector(
  recruitmentSelector,
  (state) => !!state.formInput.data?.requestId
);

export const detailStatusSelector = createSelector(
  recruitmentSelector,
  (state) => state.getDetailRecruitmentReducer.status
);

export const uploadFileStatusSelector = createSelector(
  recruitmentSelector,
  (state) => state.uploadFiles.status
);

export const stepsSelector = createSelector(
  recruitmentSelector,
  (state) => state.formInput.steps
);

export const dataBoundarySelector = createSelector(
  recruitmentSelector,
  (state) => state.getDataBoundary.data
);

export const recruitmentDepartmentPositionSelector = (state: RootState) =>
  state.recruitment.getListRecruitmentPosition.data;
